import BigButton from "components/atoms/buttons/BigButton";
import PrimaryButton from "components/atoms/buttons/PrimaryButton";
import Input from "components/atoms/input/Input";
import PhoneInput from "components/atoms/input/phone/PhoneInput";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import SelectComponent from "components/atoms/select/SelectComponent";
import { Text, ValidateWord } from "components/atoms/text/Text";
import Toggle from "components/atoms/toggle/Toggle";
import { COLORS } from "styles/colors";
import { Option } from "utils/options";
import * as s from "./MyProfileStyled";
import Camera from "components/atoms/text/labels/Camera";
import ChangeModal from "./modal/change";
import {
  PhoneVerify,
  UserDetail,
} from "api/interfaces/userInterface.interface";
import ImageCrop from "components/atoms/image/crop/ImageCrop";
import UserProfileImage from "components/blocks/headernav/sub/UserProfileImage";
import PhotoMenu from "./photomenu/PhotoMenu";
import { UPDATE_TYPE } from "./MyProfileContainer";
import AddressInput from "components/atoms/input/address/AddressInput";
import Deactivate from "components/blocks/modal/deactivate";
import DeleteConfirmModal from "components/templates/modal/small/confirm/delete";
import {
  Validate,
  ValidateMsg,
} from "api/interfaces/commonInterface.interface";
import { ThemeText } from "redux/reducers/theme/themeReducer";
import VerifyPopup from "components/templates/modal/small/verify/VerifyPopup";
import { ReactComponent as PasskeyIcon } from "assets/icons/passkey.svg";
import DeactivateUser from "pages/users/userList/add/DeactivateUser";
import CenterContentPage from "components/templates/layout/CenterContentPage";
import { WithTooltip } from "components/blocks/WithTooltip";

export type Props = {
  isModal: boolean;
  modalType: string;
  onModal: (type: string) => void;
  originName: string;
  profile: UserDetail;
  onChangeIsCrop: (type?: string) => void;
  isCrop: boolean;
  isPhotoMenu: boolean;
  profileImageUrl: string;
  // newProfileImageUrl: string;
  originProfileImageUrl: string;
  accountLevel: string;
  // onChangeProfileImage: (value: any) => void;
  onFinishProfileImage: (croppedImage: File, originFile: File) => void;
  onChangeisPhotoMenu: () => void;
  onChangeProfile: (name: string, value: string | boolean) => void;
  onChangeAddress: (type: UPDATE_TYPE, value: string) => void;
  onClickSave: () => void;
  isValidated: Validate;
  isValidatedMsg: ValidateMsg;
  onDeleteProfileImage: () => void;
  onDeleteProfileImageConfirm: () => void;
  startPageOptions: Option[];
  isDeleteProfileImageConfirm: boolean;
  onChangeTheme: (theme: "light" | "dark") => void;
  tempTheme: ThemeText;
  phoneVerify: PhoneVerify;
  onChangeVerifyCode: (value: string) => void;
  onRequestVerify: (value: string) => void;
  disabledSave: boolean;
  onConfirmAddPasskey: () => void;
  onClickRemovePasskey: (passkeyId: string) => void;
  isPasskeyEnabled: boolean;
  setSelectedPasskeyId: (passkeyId: string) => void;
  selectedPasskeyId: string;
  passkeySupported: boolean;
};

export function MyProfilePresenter({
  isModal,
  modalType,
  onModal,
  originName,
  profile,
  isCrop,
  isPhotoMenu,
  onChangeIsCrop,
  profileImageUrl,
  // newProfileImageUrl,
  originProfileImageUrl,
  accountLevel,
  // onChangeProfileImage,
  onFinishProfileImage,
  onChangeisPhotoMenu,
  onChangeProfile,
  onChangeAddress,
  onClickSave,
  isValidated,
  isValidatedMsg,
  onDeleteProfileImage,
  onDeleteProfileImageConfirm,
  startPageOptions,
  isDeleteProfileImageConfirm,
  onChangeTheme,
  tempTheme,
  phoneVerify,
  onChangeVerifyCode,
  onRequestVerify,
  disabledSave,
  onConfirmAddPasskey,
  onClickRemovePasskey,
  isPasskeyEnabled,
  setSelectedPasskeyId,
  selectedPasskeyId,
  passkeySupported,
}: Props): JSX.Element {
  const buttons = (
    <>
      <DeactivateUser email={profile.email} isProfile userId={profile.userId} />
      <BigButton
        label="Save Settings"
        onClickBtn={onClickSave}
        disabled={disabledSave}
        data-testid="setting-profile-button-click-save"
      />
    </>
  );

  return (
    <>
      <CenterContentPage titleComponent="Profile" buttons={buttons} noWrapper>
        <s.RowItem>
          <s.Item>
            <s.ProfileInner>
              <s.ProfileImageWrapper level={accountLevel}>
                <s.Camera
                  onClick={onChangeisPhotoMenu}
                  data-testid="setting-profile-camera-changeis-photo-menu"
                >
                  <s.CameraInner>
                    {isPhotoMenu && (
                      <PhotoMenu
                        profileImageUrl={profileImageUrl}
                        onChangeIsCrop={onChangeIsCrop}
                        onDeleteProfileImage={onDeleteProfileImageConfirm}
                        // onChangeProfileImage={onChangeProfileImage}
                      />
                    )}

                    <Camera />
                  </s.CameraInner>
                </s.Camera>
                <s.ProfileImage>
                  <UserProfileImage />
                </s.ProfileImage>
              </s.ProfileImageWrapper>
              <s.Name>
                <Text bold>{originName}</Text>
              </s.Name>
              <div className="account-date-info">
                <s.RowInput>
                  <Text fontSize={12} color={COLORS.BUTTONS1} bold>
                    Account Created
                  </Text>
                  <Text fontSize={12} color={COLORS.BUTTONS1}>
                    {profile.createAt}
                  </Text>
                </s.RowInput>
                <s.RowInput>
                  <Text fontSize={12} color={COLORS.BUTTONS1} bold>
                    Last Login
                  </Text>
                  <Text fontSize={12} color={COLORS.BUTTONS1}>
                    {profile.lastLoggedOn}
                  </Text>
                </s.RowInput>
              </div>
            </s.ProfileInner>
          </s.Item>
          <s.Item>
            <s.RowInput>
              <ModalInput label="First Name" noBold>
                <Input
                  //defaultValue={profile.name}
                  name="firstName"
                  maxLength={100}
                  value={profile.firstName ?? ""}
                  onChange={(e) =>
                    onChangeProfile(e.target.name, e.target.value)
                  }
                  isValidated={isValidated.firstName}
                  placeholder="Please enter a first name"
                  data-testid="setting-profile-first-name-change-profile"
                />

                {isValidated.firstName && (
                  <ValidateWord data-testid="setting-profile-validate-first-name">{isValidatedMsg.firstName}</ValidateWord>
                )}
              </ModalInput>
              <ModalInput label="Last Name" noBold>
                <Input
                  //defaultValue={profile.name}
                  name="lastName"
                  maxLength={100}
                  value={profile.lastName ?? ""}
                  onChange={(e) =>
                    onChangeProfile(e.target.name, e.target.value)
                  }
                  isValidated={isValidated.lastName}
                  placeholder="Please enter a last name"
                  data-testid="setting-profile-last-name-change-profile"
                />

                {isValidated.lastName && (
                  <ValidateWord data-testid="setting-profile-validate-last-name">{isValidatedMsg.lastName}</ValidateWord>
                )}
              </ModalInput>
            </s.RowInput>
            <ModalInput label="Email" noBold>
              <s.RowInput>
                {/* <Input disabled value={profile.email} /> */}
                <Input disabled value={profile.email ?? ""} />
                {/* email change not permit (first of all , auth check not user email but userId)*/}
                {/* <div style={{ visibility: "hidden" }}>
                      <PrimaryButton
                        label="Change"
                        buttonType="cancel"
                        disabled={
                          profile.provider !== undefined &&
                          profile.provider.toUpperCase() !== "AUTH0"
                        }
                        onClickBtn={() => onModal("email")}
                      />
                    </div> */}
              </s.RowInput>
            </ModalInput>
            <ModalInput label="Phone Number" noBold>
              <s.RowInput>
                <PhoneInput
                  style={
                    phoneVerify.isVerify || !profile.phone
                      ? {}
                      : {
                          height: "auto",
                        }
                  }
                  placeholder="Please enter a phone number"
                  onKeyDown={() => {
                    onRequestVerify("changePhoneNumber");
                  }}
                  selected={profile.phone}
                  onChange={(phoneNumber) => {
                    onChangeProfile("phone", phoneNumber);
                  }}
                  onKeyUp={() => {
                    onRequestVerify("changePhoneNumber");
                  }}
                  isValidated={
                    isValidated.phone && profile.phone ? true : false
                  }
                  data-testid="setting-profile-phone-input-change-profile"
                />

                {!phoneVerify.isVerify && profile.phone && (
                  <PrimaryButton
                    label="Verify"
                    buttonType="primary"
                    disabled={!profile.phone}
                    onClickBtn={() => onRequestVerify("phoneNumber")}
                    data-testid="setting-profile-primary-button-request-verify"
                  />
                )}

                {phoneVerify.correctCode && (
                  <VerifyPopup
                    verifyCode={phoneVerify.correctCode}
                    modalType={"phoneNumber"}
                    onModal={() => onRequestVerify("cancel")}
                    onVerify={() => onRequestVerify("codeNumber")}
                    onChange={onChangeVerifyCode}
                  />
                )}
              </s.RowInput>
              {isValidated.phone && profile.phone && (
                <ValidateWord data-testid="setting-profile-validate-phone">{isValidatedMsg.phone}</ValidateWord>
              )}
            </ModalInput>

            <ModalInput label="Address" noBold>
              <AddressInput
                isLoaded={true}
                value={profile.address ?? ""}
                onChange={(e) =>
                  onChangeAddress(UPDATE_TYPE.USER_ADDR, e.currentTarget.value)
                }
                onChangeLocationSelect={(
                  address: google.maps.LatLngLiteral,
                  addressString?: string
                ) => {
                  if (addressString !== undefined) {
                    onChangeProfile("address", addressString);
                  }
                }}
                data-testid="setting-profile-address-input-change-address"
              />
            </ModalInput>
          </s.Item>
        </s.RowItem>
        <s.Item className="security-item">
          <Text bold>Security</Text>
          <s.RowInput className="input-item">
            <ModalInput label="Password" noBold flex={2}>
              <s.RowInput>
                <Input disabled type="password" value="000000000000" />

                <PrimaryButton
                  label="Change"
                  buttonType="cancel"
                  disabled={
                    profile.provider !== undefined &&
                    (profile.provider || "").toUpperCase() !== "AUTH0"
                  }
                  onClickBtn={() => onModal("password")}
                  data-testid="setting-profile-primary-button-modal"
                />
              </s.RowInput>
            </ModalInput>
            <ModalInput label="Two-Factor Authentication (2FA)" flex={1} noBold>
              <s.CheckWrapper>
                <label>
                  <input
                    type="radio"
                    value="email"
                    name="use2faCode"
                    onChange={(e) =>
                      onChangeProfile(e.target.name, e.target.value)
                    }
                    checked={profile.use2faCode === "email"}
                    data-testid="setting-profile-use2fa-code-radio-email"
                  />{" "}
                  Email
                </label>
                <WithTooltip
                  style={{ width: 150 }}
                  tooltip="When “Phone” is selected, “Receive SMS” is automatically enabled and cannot be disabled."
                >
                  <label>
                    <input
                      type="radio"
                      value="phone"
                      name="use2faCode"
                      onChange={(e) =>
                        onChangeProfile(e.target.name, e.target.value)
                      }
                      disabled={
                        !profile.phone ||
                        (profile.phone && !phoneVerify.isVerify)
                          ? true
                          : false
                      }
                      checked={profile.use2faCode === "phone"}
                      data-testid="setting-profile-use2fa-code-radio-phone"
                    />{" "}
                    Phone
                  </label>
                </WithTooltip>
              </s.CheckWrapper>
            </ModalInput>
          </s.RowInput>
          {isPasskeyEnabled && (
            <ModalInput
              label={
                <s.PasskeyLabel>
                  <span>Passkey</span>
                  {profile.passkeyList.length < 3 && passkeySupported && (
                    <Deactivate
                      title="Do you want to add passkey?"
                      subTitle="Please enter your password"
                      onDeactive={onConfirmAddPasskey}
                      button={({ onClick, disabled }) => (
                        <s.AddPasskey
                          onClick={onClick}
                          disabled={disabled}
                          data-testid="setting-profile-add-passkey-click"
                        >
                          Add
                        </s.AddPasskey>
                      )}
                    />
                  )}
                </s.PasskeyLabel>
              }
              noBold
            >
              {profile.passkeyList.length > 0 &&
                profile.passkeyList.map((passkey) => (
                  <s.PasskeyItem key={passkey.passkeyId}>
                    <s.PasskeyIconWrapper>
                      <PasskeyIcon />
                    </s.PasskeyIconWrapper>
                    <s.PasskeyItemContent>
                      <b>{passkey.keyName}</b>
                      <small>Created: {passkey.createAt}</small>
                      <s.PasskeyRemove
                        onClick={() => setSelectedPasskeyId(passkey.passkeyId)}
                        data-testid="setting-profile-passkey-remove-set-selected-passkey-id"
                      >
                        Remove
                      </s.PasskeyRemove>
                    </s.PasskeyItemContent>
                  </s.PasskeyItem>
                ))}
            </ModalInput>
          )}
        </s.Item>
        <s.Item className="company-item">
          <Text bold>Company</Text>
          <s.RowInput className="input-item">
            <ModalInput label="Name" noBold>
              <Input
                name="companyName"
                placeholder="Please enter a company name"
                maxLength={100}
                value={profile.companyName ?? ""}
                onChange={(e) => onChangeProfile(e.target.name, e.target.value)}
                data-testid="setting-profile-company-name-change-profile"
              />
            </ModalInput>
            <ModalInput label="Department" noBold>
              <Input
                name="department"
                placeholder="Please enter a department"
                maxLength={100}
                value={profile.department ?? ""}
                onChange={(e) => onChangeProfile(e.target.name, e.target.value)}
                data-testid="setting-profile-department-change-profile"
              />
            </ModalInput>
            <ModalInput label="Job Title" noBold>
              <Input
                name="jobTitle"
                placeholder="Please enter a job title"
                maxLength={100}
                value={profile.jobTitle ?? ""}
                onChange={(e) => onChangeProfile(e.target.name, e.target.value)}
                data-testid="setting-profile-job-title-change-profile"
              />
            </ModalInput>
          </s.RowInput>
          <s.RowInput className="input-item">
            <ModalInput label="Address" noBold flex={2}>
              <AddressInput
                isLoaded={true}
                value={profile.companyAddress}
                onChange={(e) =>
                  onChangeAddress(
                    UPDATE_TYPE.COMPANY_ADDR,
                    e.currentTarget.value
                  )
                }
                onChangeLocationSelect={(
                  address: google.maps.LatLngLiteral,
                  addressString?: string
                ) => {
                  if (addressString !== undefined) {
                    onChangeProfile("companyAddress", addressString);
                  }
                }}
                data-testid="setting-profile-address-input-change-address-2"
              />
            </ModalInput>
            <ModalInput
              label="Phone"
              noBold
              isValidated={isValidated.companyPhoneNumber}
              validatedWord={isValidatedMsg.companyPhoneNumber}
              flex={1}
            >
              {/* <s.RowInput> */}
              <PhoneInput
                placeholder="Please enter a phone number"
                selected={profile.companyPhoneNumber ?? ""}
                onChange={(phoneNumber) => {
                  onChangeProfile("companyPhoneNumber", phoneNumber);
                }}
                data-testid="setting-profile-phone-input-change-profile-2"
              />

              {/* </s.RowInput> */}
            </ModalInput>
          </s.RowInput>
        </s.Item>

        <s.Item>
          <s.RowInput className="input-item">
            <ModalInput label="Start Page" flex={1} noBold>
              <SelectComponent
                options={startPageOptions}
                value={profile.startPage}
                onChange={(value) => {
                  onChangeProfile("startPage", value as string);
                }}
                data-testid="setting-profile-selects-change-profile"
              />
            </ModalInput>
          </s.RowInput>
          <s.RowInput className="input-item toggle-item">
            <ModalInput label="Receive alert emails" flex={1} noBold>
              <Toggle
                isToggled={profile.notifyAlertMail}
                checked={profile.notifyAlertMail}
                onChange={(checked) => {
                  onChangeProfile("notifyAlertMail", checked);
                }}
                dataTestId="setting-profile-receive-alert-emails-toggle"
              />
            </ModalInput>
            <ModalInput label="Receive report emails" flex={1} noBold>
              <Toggle
                isToggled={profile.notifyReportMail}
                checked={profile.notifyReportMail}
                onChange={(checked) => {
                  onChangeProfile("notifyReportMail", checked);
                }}
                dataTestId="setting-profile-receive-report-emails-toggle"
              />
            </ModalInput>
            <ModalInput label="Receive push notifications" flex={1} noBold>
              <Toggle
                isToggled={profile.notifyPush}
                checked={profile.notifyPush}
                onChange={(checked) => onChangeProfile("notifyPush", checked)}
                dataTestId="setting-profile-receive-push-notifications-toggle"
              />
            </ModalInput>
          </s.RowInput>
          <s.RowInput className="toggle-item">
            <ModalInput label="Receive SMS" flex={1} noBold>
              <Toggle
                isToggled={profile.notifySms}
                checked={profile.notifySms}
                disabled={
                  !profile.phone ||
                  (profile.phone &&
                    profile.use2faCode === "phone" &&
                    phoneVerify.isVerify)
                    ? true
                    : false
                }
                onChange={(checked) => {
                  onChangeProfile("notifySms", checked);
                }}
                dataTestId="setting-profile-receive-sms-toggle"
              />
            </ModalInput>
            <ModalInput label="Newsletters" flex={1} noBold>
              <Toggle
                isToggled={profile.newsLetter}
                checked={profile.newsLetter}
                // label={"Subscribed"}
                label={profile.newsLetter ? "Subscribed" : "Subscribe"}
                onChange={(checked) => {
                  onChangeProfile("newsLetter", checked);
                }}
                dataTestId="setting-profile-newsletters-toggle"
              />
            </ModalInput>
            <ModalInput label="Theme" flex={1} noBold>
              <Toggle
                label={tempTheme === "light" ? "Light" : "Dark"}
                isToggled={tempTheme === "light"}
                // onChange={() => dispatch(setMode())}
                onChange={(checked) =>
                  onChangeTheme(checked ? "light" : "dark")
                }
                dataTestId="setting-profile-theme-toggle"
              />
            </ModalInput>
          </s.RowInput>
        </s.Item>
      </CenterContentPage>
      {isModal && (
        <ChangeModal
          email={profile.email}
          phone={profile.phone}
          userId={profile.userId}
          modalType={modalType}
          onModal={onModal}
        />
      )}

      {isCrop && (
        <ImageCrop
          // newUrl={newProfileImageUrl}
          originUrl={originProfileImageUrl}
          onModal={() => onChangeIsCrop("close")}
          onFinish={onFinishProfileImage}
          // onChange={onChangeProfileImage}
        />
      )}

      {isDeleteProfileImageConfirm && (
        <DeleteConfirmModal
          label="Profile Image"
          onDelete={onDeleteProfileImageConfirm}
          onConfirmDelete={onDeleteProfileImage}
        />
      )}

      {selectedPasskeyId !== "" && (
        <DeleteConfirmModal
          label="Passkey"
          onDelete={() => setSelectedPasskeyId("")}
          onConfirmDelete={() => onClickRemovePasskey(selectedPasskeyId)}
        />
      )}
    </>
  );
}
